import { common } from '@/common/service/ApiList';
import ServiceExec from '@/common/utils/ServiceExec';
import { CODE_ENV_LIST } from '@/common/constants/ConstCode';

const { createDynamicLink } = common;
const { REQUEST_DOMAIN } = CODE_ENV_LIST;
export default {
  CREATE_DYNAMIC_LINK: async ({ state }, link) => {
    const { status, data } = await ServiceExec.get(createDynamicLink, {
      link
    });
    if (status === ServiceExec.status.OK) {
      const { shortLink, previewLink } = data;

      return shortLink;
    }
    return null;
  }
};
